import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ResponseTime from './ResponseTime';

const Responsiveness = ({ bucket, hours }) => {
  return (
    <div className="responsive-wrapper">
      {bucket || hours
        ? <FormattedMessage
          id="shared_components.responsiveness.text"
          defaultMessage="Responds {bucket_text}"
          values={{ bucket_text: hours ? <ResponseTime hours={hours} /> : bucket }}
        /> : <FormattedMessage id="shared_components.responsiveness.new_space" defaultMessage="New space" />
      }
    </div>
  );
};

ResponseTime.propTypes = {
  bucket: PropTypes.string,
  hours: PropTypes.number
};

export default Responsiveness;
